import {
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
} from '@mui/icons-material';
import { set, get } from 'object-path';

import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useRecoilState } from 'recoil';
import { layoutSelector } from 'state';
import { produce } from 'immer';

interface OrganizationControlsProps {
  path: string;
  disabled?: boolean;
}
export default function OrganizationControls({
  path,
  disabled,
}: OrganizationControlsProps) {
  const [layout, setLayout] = useRecoilState(layoutSelector);
  const stylePath = `${path}.layoutOptions.style`;
  const row = get(layout, path);
  const onChangeAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    const items = produce(layout, draft => {
      set(draft, stylePath, {
        justifyContent: newAlignment,
      });
    });
    setLayout(items);
  };

  return (
    <ToggleButtonGroup
      value={row.layoutOptions?.style?.justifyContent ?? 'start'}
      exclusive
      onChange={onChangeAlignment}
      aria-label="text alignment"
      sx={{ mr: 1 }}
      disabled={disabled}
    >
      <ToggleButton value="start" aria-label="left aligned" size="small">
        <FormatAlignLeft fontSize="small" />
      </ToggleButton>
      <ToggleButton value="space-around" aria-label="centered" size="small">
        <FormatAlignCenter fontSize="small" />
      </ToggleButton>
      <ToggleButton value="end" aria-label="right aligned" size="small">
        <FormatAlignRight fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
